import React, { Component } from 'react';
import { Field, FieldArray, reduxForm, formValueSelector } from 'redux-form';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import submit from './submit';
import validate from './validate';

import cx from 'classnames';
import { Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import FieldArrayComponent from '../../../CommonFields/FieldArrayComponent';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import { formatLocaleData } from '../../../../helpers/formatLocale';

import cs from '../../../../components/commonStyle.css';
import s from './WhyHostFormBlock2.css';
import messages from '../../../../locale/jsonMessages';

const block2ActiveFields = ['earnBlockTitle1', 'earnBlockContent1'];

class WhyHostFormBlock2 extends Component {

  render() {

    const { error, handleSubmit, submitting, selectedLanguage } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className='siteAdminCenterContainer siteAdminCenterContainerBox'>
        <h1 className='siteAdminHeading'><FormattedMessage {...messages.WhyBecomeOwnerBlock2} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className="oneColumnGrid">
            <FieldArray
              name="dynamicWhyHostInfoBlock"
              component={FieldArrayComponent}
              activesFields={block2ActiveFields}
              filedName="dynamicWhyHostInfoBlock"
              selectedLanguage={selectedLanguage}
              label={formatMessage(messages.earnBlockTitle)}
              placeholder={formatMessage(messages.earnBlockTitle)}
            />
          </div>
          <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting}>
              <FormattedMessage {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }

}

WhyHostFormBlock2 = reduxForm({
  form: 'WhyHostForm',
  validate
})(WhyHostFormBlock2);

const selector = formValueSelector('WhyHostForm');

const mapState = (state) => ({
  selectedLanguage: selector(state, 'dynamicWhyHostInfoBlock'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

export default compose(
  withStyles(cs, s),
  injectIntl,
  connect(mapState, {}),
)(WhyHostFormBlock2);
